<p-accordion 
  class="observation-list" 
  (onClose)="activeTarget = undefined;" 
  (onOpen)="activeTarget = undefined;">
  @for (observation of observations; track observation.id || $index; let i = $index) {
    <p-accordionTab [value]="i">
      <ng-template pTemplate="header">
        <div class="title">{{ observation.help }}</div>
      </ng-template>
      <ng-template pTemplate="content">
        <div class="observation-content">
          @if (observation.nodes && observation.nodes.length > 0) {
            <div class="nodes-container">
              @for (node of observation.nodes; track $index) {
                <div class="nodes">
                  @for (target of node.target; track $index) {
                    <div class="targets">
                      <div 
                        class="target" 
                        [ngClass]="{'active': activeTarget?.target.toString() === target.toString()}"
                        (click)="showObservation(observation, node, target)">
                        <fa-icon [icon]="faInfoSquare"></fa-icon>
                      </div>
                    </div>
                  }
                </div>
              }

            </div>
          }

          @if (activeTarget) {
            <div class="details">
              <div class="form-section no-infos node-info">
                <div class="form-section-content flex">
                  @if (observation.tags) {
                    <div class="form-item">
                      <label class="form-label">WCAG Mapping</label>
                      <div class="wcag-mapping">
                        @for (label of observation.tags; track $index) {
                          <div class="wcag-label">{{ label }}</div>
                        }
                      </div>
                    </div>
                  }

                  @if (activeTarget.a11yScore) {
                    <div class="form-item">
                        <div class="score-container">
                        <p-progressBar
                            [value]="activeTarget.a11yScore * 10"
                            [showValue]="false">
                        </p-progressBar>
                        <span class="score-text">
                            {{ activeTarget.a11yScore }}/10 Accessibility Score
                            <fa-icon
                            [icon]="faInfoCircle"
                            pTooltip="Likelihood of fulfilling A11y Requirements"
                            tooltipPosition="top">
                            </fa-icon>
                        </span>
                        </div>
                    </div>
                  }

                  @if (activeTarget.actRequirement) {
                    <div class="form-item">
                      <label class="form-label">ACT Requirement</label>
                      <div class="description" [innerHTML]="activeTarget.actRequirement"></div>
                    </div>
                  }

                  @if (observation.description) {
                    <div class="form-item">
                      <label class="form-label">Rule Description</label>
                      <div class="description">{{ observation.description }}</div>
                    </div>
                  }

                  @if (activeTargetFailureSummary && observationType === 'violation') {
                    <div class="form-item">
                      <label class="form-label">Failure Summary</label>
                      <div class="description" [innerHTML]="activeTargetFailureSummary"></div>
                    </div>
                  }

                  @if (activeTarget.text) {
                    <div class="form-item">
                      <label class="form-label">Text Content</label>
                      <div class="description">{{ activeTarget.text }}</div>
                    </div>
                  }

                  @if (activeTarget.alternativeCaption) {
                    <div class="form-item">
                      <label class="form-label">Suggested Alternative Text</label>
                      <div class="description" [innerHTML]="activeTarget.alternativeCaption"></div>
                    </div>
                  }

                  @if (activeTarget.target) {
                    <div class="form-item">
                      <label class="form-label">Selector</label>
                      <div class="target">
                        <pre><code>{{ activeTarget.target }}</code></pre>
                      </div>
                    </div>
                  }

                  @if (activeElement?.htmlString) {
                    <div class="form-item">
                      <label class="form-label">HTML</label>
                      <div class="html">
                        <pre><code>{{ activeElement.htmlString }}</code></pre>
                      </div>
                    </div>
                  }

                  @if (activeElement?.elementScreenshot) {
                    <div class="form-item">
                      <label class="form-label">Screenshot</label>
                      <wm-image 
                        [imageId]="activeElement.elementScreenshot" 
                        [infoItems]="activeElementStateInfos || []">
                      </wm-image>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </ng-template>
    </p-accordionTab>
  }
</p-accordion>
